<div [ngStyle]="{'margin-left': (group.column.groupIndex * 8) + 'px'}" class="flex flex-row flex-wrap w-full items-center cursor-pointer">
<i
  [ngClass]="{'datagrid-custom-expand': true, 'dx-icon-chevronnext': !group.row.isExpanded, 'dx-icon-chevrondown': group.row.isExpanded }"></i>
<span class="block font-normal uppercase group-name">{{group.value}} ({{group.summaryItems[0].value}})</span>
</div>
